"use strict";
// tslint:disable
/**
 * Model Catalog
 * This is the API of the Software Description Ontology at [https://w3id.org/okn/o/sdm](https://w3id.org/okn/o/sdm)
 *
 * The version of the OpenAPI document: v1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HybridModelToJSON = exports.HybridModelFromJSONTyped = exports.HybridModelFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function HybridModelFromJSON(json) {
    return HybridModelFromJSONTyped(json, false);
}
exports.HybridModelFromJSON = HybridModelFromJSON;
function HybridModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasDownloadInstructions': !runtime_1.exists(json, 'hasDownloadInstructions') ? undefined : json['hasDownloadInstructions'],
        'keywords': !runtime_1.exists(json, 'keywords') ? undefined : json['keywords'],
        'hasDocumentation': !runtime_1.exists(json, 'hasDocumentation') ? undefined : json['hasDocumentation'],
        'hasGrid': !runtime_1.exists(json, 'hasGrid') ? undefined : json['hasGrid'].map(_1.GridFromJSON),
        'softwareRequirements': !runtime_1.exists(json, 'softwareRequirements') ? undefined : json['softwareRequirements'],
        'hasDownloadURL': !runtime_1.exists(json, 'hasDownloadURL') ? undefined : json['hasDownloadURL'],
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'hasInstallationInstructions': !runtime_1.exists(json, 'hasInstallationInstructions') ? undefined : json['hasInstallationInstructions'],
        'compatibleVisualizationSoftware': !runtime_1.exists(json, 'compatibleVisualizationSoftware') ? undefined : json['compatibleVisualizationSoftware'].map(_1.SoftwareFromJSON),
        'copyrightHolder': !runtime_1.exists(json, 'copyrightHolder') ? undefined : json['copyrightHolder'],
        'hasFAQ': !runtime_1.exists(json, 'hasFAQ') ? undefined : json['hasFAQ'],
        'logo': !runtime_1.exists(json, 'logo') ? undefined : json['logo'].map(_1.ImageFromJSON),
        'hasContactPerson': !runtime_1.exists(json, 'hasContactPerson') ? undefined : json['hasContactPerson'],
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'limitations': !runtime_1.exists(json, 'limitations') ? undefined : json['limitations'],
        'identifier': !runtime_1.exists(json, 'identifier') ? undefined : json['identifier'],
        'author': !runtime_1.exists(json, 'author') ? undefined : json['author'],
        'hasBuildFile': !runtime_1.exists(json, 'hasBuildFile') ? undefined : json['hasBuildFile'],
        'shortDescription': !runtime_1.exists(json, 'shortDescription') ? undefined : json['shortDescription'],
        'datePublished': !runtime_1.exists(json, 'datePublished') ? undefined : json['datePublished'],
        'theoreticalBasis': !runtime_1.exists(json, 'theoreticalBasis') ? undefined : json['theoreticalBasis'],
        'license': !runtime_1.exists(json, 'license') ? undefined : json['license'],
        'hasSourceCode': !runtime_1.exists(json, 'hasSourceCode') ? undefined : json['hasSourceCode'].map(_1.SourceCodeFromJSON),
        'hasExplanationDiagram': !runtime_1.exists(json, 'hasExplanationDiagram') ? undefined : json['hasExplanationDiagram'].map(_1.ImageFromJSON),
        'hasExample': !runtime_1.exists(json, 'hasExample') ? undefined : json['hasExample'],
        'publisher': !runtime_1.exists(json, 'publisher') ? undefined : json['publisher'],
        'runtimeEstimation': !runtime_1.exists(json, 'runtimeEstimation') ? undefined : json['runtimeEstimation'],
        'doi': !runtime_1.exists(json, 'doi') ? undefined : json['doi'],
        'hasFunding': !runtime_1.exists(json, 'hasFunding') ? undefined : json['hasFunding'].map(_1.FundingInformationFromJSON),
        'hasProcess': !runtime_1.exists(json, 'hasProcess') ? undefined : json['hasProcess'].map(_1.ProcessFromJSON),
        'supportDetails': !runtime_1.exists(json, 'supportDetails') ? undefined : json['supportDetails'],
        'hasVersion': !runtime_1.exists(json, 'hasVersion') ? undefined : json['hasVersion'].map(_1.SoftwareVersionFromJSON),
        'hasTypicalDataSource': !runtime_1.exists(json, 'hasTypicalDataSource') ? undefined : json['hasTypicalDataSource'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'referencePublication': !runtime_1.exists(json, 'referencePublication') ? undefined : json['referencePublication'],
        'screenshot': !runtime_1.exists(json, 'screenshot') ? undefined : json['screenshot'].map(_1.ImageFromJSON),
        'hasModelCategory': !runtime_1.exists(json, 'hasModelCategory') ? undefined : json['hasModelCategory'].map(_1.ModelCategoryFromJSON),
        'hadPrimarySource': !runtime_1.exists(json, 'hadPrimarySource') ? undefined : json['hadPrimarySource'],
        'issueTracker': !runtime_1.exists(json, 'issueTracker') ? undefined : json['issueTracker'],
        'dateCreated': !runtime_1.exists(json, 'dateCreated') ? undefined : json['dateCreated'],
        'contributor': !runtime_1.exists(json, 'contributor') ? undefined : json['contributor'].map(_1.PersonFromJSON),
        'hasInputVariable': !runtime_1.exists(json, 'hasInputVariable') ? undefined : json['hasInputVariable'].map(_1.VariablePresentationFromJSON),
        'hasPurpose': !runtime_1.exists(json, 'hasPurpose') ? undefined : json['hasPurpose'],
        'hasExecutableInstructions': !runtime_1.exists(json, 'hasExecutableInstructions') ? undefined : json['hasExecutableInstructions'],
        'hasSampleVisualization': !runtime_1.exists(json, 'hasSampleVisualization') ? undefined : json['hasSampleVisualization'].map(_1.VisualizationFromJSON),
        'memoryRequirements': !runtime_1.exists(json, 'memoryRequirements') ? undefined : json['memoryRequirements'],
        'website': !runtime_1.exists(json, 'website') ? undefined : json['website'],
        'citation': !runtime_1.exists(json, 'citation') ? undefined : json['citation'],
        'processorRequirements': !runtime_1.exists(json, 'processorRequirements') ? undefined : json['processorRequirements'],
        'parameterization': !runtime_1.exists(json, 'parameterization') ? undefined : json['parameterization'],
        'hasUsageNotes': !runtime_1.exists(json, 'hasUsageNotes') ? undefined : json['hasUsageNotes'],
        'readme': !runtime_1.exists(json, 'readme') ? undefined : json['readme'],
        'label': !runtime_1.exists(json, 'label') ? undefined : json['label'],
        'hasAssumption': !runtime_1.exists(json, 'hasAssumption') ? undefined : json['hasAssumption'],
        'operatingSystems': !runtime_1.exists(json, 'operatingSystems') ? undefined : json['operatingSystems'],
        'hasExecutableNotebook': !runtime_1.exists(json, 'hasExecutableNotebook') ? undefined : json['hasExecutableNotebook'],
        'hasEquation': !runtime_1.exists(json, 'hasEquation') ? undefined : json['hasEquation'].map(_1.EquationFromJSON),
        'usefulForCalculatingIndex': !runtime_1.exists(json, 'usefulForCalculatingIndex') ? undefined : json['usefulForCalculatingIndex'].map(_1.NumericalIndexFromJSON),
        'hasOutputVariable': !runtime_1.exists(json, 'hasOutputVariable') ? undefined : json['hasOutputVariable'].map(_1.VariablePresentationFromJSON),
    };
}
exports.HybridModelFromJSONTyped = HybridModelFromJSONTyped;
function HybridModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hasDownloadInstructions': value.hasDownloadInstructions,
        'keywords': value.keywords,
        'hasDocumentation': value.hasDocumentation,
        'hasGrid': value.hasGrid === undefined ? undefined : value.hasGrid.map(_1.GridToJSON),
        'softwareRequirements': value.softwareRequirements,
        'hasDownloadURL': value.hasDownloadURL,
        'type': value.type,
        'hasInstallationInstructions': value.hasInstallationInstructions,
        'compatibleVisualizationSoftware': value.compatibleVisualizationSoftware === undefined ? undefined : value.compatibleVisualizationSoftware.map(_1.SoftwareToJSON),
        'copyrightHolder': value.copyrightHolder,
        'hasFAQ': value.hasFAQ,
        'logo': value.logo === undefined ? undefined : value.logo.map(_1.ImageToJSON),
        'hasContactPerson': value.hasContactPerson,
        'id': value.id,
        'limitations': value.limitations,
        'identifier': value.identifier,
        'author': value.author,
        'hasBuildFile': value.hasBuildFile,
        'shortDescription': value.shortDescription,
        'datePublished': value.datePublished,
        'theoreticalBasis': value.theoreticalBasis,
        'license': value.license,
        'hasSourceCode': value.hasSourceCode === undefined ? undefined : value.hasSourceCode.map(_1.SourceCodeToJSON),
        'hasExplanationDiagram': value.hasExplanationDiagram === undefined ? undefined : value.hasExplanationDiagram.map(_1.ImageToJSON),
        'hasExample': value.hasExample,
        'publisher': value.publisher,
        'runtimeEstimation': value.runtimeEstimation,
        'doi': value.doi,
        'hasFunding': value.hasFunding === undefined ? undefined : value.hasFunding.map(_1.FundingInformationToJSON),
        'hasProcess': value.hasProcess === undefined ? undefined : value.hasProcess.map(_1.ProcessToJSON),
        'supportDetails': value.supportDetails,
        'hasVersion': value.hasVersion === undefined ? undefined : value.hasVersion.map(_1.SoftwareVersionToJSON),
        'hasTypicalDataSource': value.hasTypicalDataSource,
        'description': value.description,
        'referencePublication': value.referencePublication,
        'screenshot': value.screenshot === undefined ? undefined : value.screenshot.map(_1.ImageToJSON),
        'hasModelCategory': value.hasModelCategory === undefined ? undefined : value.hasModelCategory.map(_1.ModelCategoryToJSON),
        'hadPrimarySource': value.hadPrimarySource,
        'issueTracker': value.issueTracker,
        'dateCreated': value.dateCreated,
        'contributor': value.contributor === undefined ? undefined : value.contributor.map(_1.PersonToJSON),
        'hasInputVariable': value.hasInputVariable === undefined ? undefined : value.hasInputVariable.map(_1.VariablePresentationToJSON),
        'hasPurpose': value.hasPurpose,
        'hasExecutableInstructions': value.hasExecutableInstructions,
        'hasSampleVisualization': value.hasSampleVisualization === undefined ? undefined : value.hasSampleVisualization.map(_1.VisualizationToJSON),
        'memoryRequirements': value.memoryRequirements,
        'website': value.website,
        'citation': value.citation,
        'processorRequirements': value.processorRequirements,
        'parameterization': value.parameterization,
        'hasUsageNotes': value.hasUsageNotes,
        'readme': value.readme,
        'label': value.label,
        'hasAssumption': value.hasAssumption,
        'operatingSystems': value.operatingSystems,
        'hasExecutableNotebook': value.hasExecutableNotebook,
        'hasEquation': value.hasEquation === undefined ? undefined : value.hasEquation.map(_1.EquationToJSON),
        'usefulForCalculatingIndex': value.usefulForCalculatingIndex === undefined ? undefined : value.usefulForCalculatingIndex.map(_1.NumericalIndexToJSON),
        'hasOutputVariable': value.hasOutputVariable === undefined ? undefined : value.hasOutputVariable.map(_1.VariablePresentationToJSON),
    };
}
exports.HybridModelToJSON = HybridModelToJSON;
